var map = {
	"./Header": "bd61",
	"./Header.vue": "bd61",
	"./HeaderMenu": "89c1",
	"./HeaderMenu.vue": "89c1",
	"./data/sections": "41c7",
	"./data/sections.json": "41c7",
	"./img/ar-sm-d.svg": "469d",
	"./img/country/russian.png": "5545",
	"./img/header-menu-ico/balance.svg": "b1a7",
	"./img/header-menu-ico/exit.svg": "6aa2",
	"./img/header-menu-ico/game-accounts.svg": "eeb2",
	"./img/header-menu-ico/my-duels.svg": "ebee",
	"./img/header-menu-ico/profile.svg": "a265",
	"./img/header-menu-ico/referal.svg": "a74c",
	"./img/header-menu-ico/settings.svg": "262b",
	"./img/header-menu-ico/social.svg": "ecff",
	"./img/header-menu-ico/tournaments.svg": "97fb",
	"./img/notifications.svg": "b3d9",
	"./img/plus.svg": "c60e",
	"./img/user-avatar.png": "8d01",
	"./img/user-avatar1.jpg": "5194"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f847";